import ConstructionPageContent from '../components/construction/ConstructionPageContent';

const ConstructionPage = () => {
  return <ConstructionPageContent />;
};

export default ConstructionPage;